import $ from 'jquery';

class ScrollTo {

	constructor(element, options) {
		const config = $.extend({
			offset: [
				'.header',
				'.mainnav'
			],
			delay: 2000
		}, options);

		this.init(element, config);
	}

	init(element, config) {
		const offset = this.getOffsetHeight(config);

		this.initListener(element, offset, config);
	}

	initListener(element, offset, config) {
		element.addEventListener('SCROLLTO', (event) => {
			if (event.detail && event.detail.element) {
				this.scrollTo($(event.detail.element), offset, config);
			}
		});
	}

	getOffsetHeight(config) {
		let height = 0;

		for (let i = 0; i < config.offset.length; i++) {
			height += $(config.offset[i]).height() || 0;
		}

		return height;
	}

	scrollTo($element, offset, config) {
		const elementOffset = $element.offset().top;

		$('html, body').animate({
			scrollTop: (elementOffset - offset)
		}, config.delay);
	}

}

export default ScrollTo;



// WEBPACK FOOTER //
// ./js/modules/scrollto.js